// header.jsx
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiMenu, FiX, FiUser, FiSettings, FiLogOut, FiSun, FiMoon, FiBell } from "react-icons/fi";
import "./header.css";

export default function Header({
  collapsed,
  setCollapsed,
  darkMode,
  setDarkMode,
}) {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const dropdownRef = useRef(null);
  const notificationRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setShowMenu(false);
      }
      if (
        notificationRef.current &&
        !notificationRef.current.contains(e.target)
      ) {
        setShowNotifications(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setShowMenu(false);
    navigate("/");
  };

  const toggleTheme = () => {
    setDarkMode(!darkMode);
    localStorage.setItem('theme', !darkMode ? 'dark' : 'light');
  };

  const notifications = [
    { id: 1, title: "New user registered", time: "5 min ago" },
    { id: 2, title: "Payment received", time: "1 hour ago" },
    { id: 3, title: "Subscription expired", time: "3 hours ago" },
  ];

  return (
    <header className={`top-header ${darkMode ? 'dark' : ''}`}>
      <div className="header-left">
        <button
          className="menu-btn"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <FiMenu size={22} /> : <FiX size={22} />}
        </button>
        
        <div className="header-search">
          <input 
            type="text" 
            placeholder="Search..." 
            className="header-search-input"
          />
        </div>
      </div>

      <div className="header-right">
        {/* Theme Toggle */}
        <button 
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label="Toggle theme"
        >
          {darkMode ? <FiSun size={20} /> : <FiMoon size={20} />}
        </button>

        {/* Notifications */}
        <div className="notification-wrapper" ref={notificationRef}>
          <button 
            className="notification-btn"
            onClick={() => setShowNotifications(!showNotifications)}
            aria-label="Notifications"
          >
            <FiBell size={20} />
            <span className="notification-badge">3</span>
          </button>

          {showNotifications && (
            <div className="notification-dropdown">
              <div className="notification-header">
                <strong>Notifications</strong>
                <button className="mark-all-read">Mark all read</button>
              </div>
              <div className="notification-list">
                {notifications.map(notif => (
                  <div key={notif.id} className="notification-item">
                    <div className="notification-content">
                      <span className="notification-title">{notif.title}</span>
                      <span className="notification-time">{notif.time}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Profile */}
        <div className="profile-wrapper" ref={dropdownRef}>
          <div
            className="user-avatar"
            onClick={() => setShowMenu(!showMenu)}
          >
            <span>SV</span>
          </div>

          {showMenu && (
            <div className={`profile-dropdown ${darkMode ? 'dark' : ''}`}>
              <div className="dropdown-user">
                <strong>Shiv Varma</strong>
                <small>admin@dharmiq.com</small>
              </div>

              <div className="dropdown-divider" />

              <button type="button" className="dropdown-item">
                <FiUser size={16} />
                <span>Profile</span>
              </button>

              <button type="button" className="dropdown-item">
                <FiSettings size={16} />
                <span>Settings</span>
              </button>

              <button
                type="button"
                className="dropdown-item logout"
                onClick={handleLogout}
              >
                <FiLogOut size={16} />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}